import { GetFinanceAccountsApi } from "@/features/accounts/finance/services/get-accounts-api";
import { GetFinanceAccountsRequestModel } from "@/features/accounts/finance/services/get-accounts-model";

/// 銀行口座一覧取得処理
export class GetFinanceAccountsService {
  private getFinanceAccountsApi = new GetFinanceAccountsApi();

  /**
   * 銀行口座一覧取得API実行
   */
  public async getFinanceAccounts(param: GetFinanceAccountsRequestModel) {
    return await this.getFinanceAccountsApi.getFinanceAccounts(param);
  }
}
